export const TransactionLimitDisplay = ({
  label,
  limit,
}: {
  limit?: string | number;
  label: string;
}) => {
  return (
    <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 dark:bg-gray-900 justify-between">
      <p className="text-slate-500 dark:text-slate-100 text-sm">{label}</p>
      <p className="text-sm font-medium text-gray-700 w-1/2 dark:text-gray-100">
        {limit || 'Not Set'}
      </p>
    </div>
  );
};
